import React, { lazy, Suspense, useContext } from "react";
import ScSale from "./snapshots/ScSale";
import EntityContext from "../../../../context/entityContext";
import authService from "../../../../services/authService";

const ScPurchase = lazy(() => import("./snapshots/ScPurchase"));

export default function SupplyChainSnapshot() {

  const { constants } = authService.getCurrentUser();
  const { selectedBusinessType } = useContext(EntityContext);

  return (
    <>
      {selectedBusinessType == constants.BUSINESS_TYPE.PURCHASE ? (
        <Suspense fallback={<div>Loading...</div>}>
          <ScPurchase />
        </Suspense>
      ) : (
        <ScSale />
      )}
    </>
  );
}